import { t } from '@lingui/core/macro';
import { pxToRem, theme } from '@pocketlaw/tetris';
import { css } from 'styled-components';
const pleditorMentionsListHeader = css `
  pointer-events: none;
  width: 100%;
  height: ${pxToRem(40)};
  display: flex;
  align-items: center;
  padding-left: ${theme.spacing.lg};
  color: ${theme.semantic.foreground.secondary};
  font-size: ${theme.fontSize.small};
`;
export const mentionStyles = css `
  .ck-mentions {
    .ck-list__item {
      .ck-custom-mention-item {
        height: ${pxToRem(40)};
        display: flex;
        align-items: center;
        color: ${theme.semantic.foreground.primary};
        font-size: ${theme.fontSize.medium};

        &.ck-button {
          padding-left: ${theme.spacing.lg};
        }
      }

      &:has(.ck-custom-mention-first-item-with-access)::before {
        ${pleditorMentionsListHeader};
        content: '${() => t({
    comment: 'Pleditor comment mention user list header - Users with access',
    message: 'With access',
})}';
      }

      &:has(.ck-custom-mention-first-item-without-access)::before {
        ${pleditorMentionsListHeader};
        content: '${() => t({
    comment: 'Pleditor comment mention user list header - Users without access',
    message: 'Without access',
})}';
      }

      &:has(.ck-custom-mention-first-item-external)::before {
        ${pleditorMentionsListHeader};
        content: '${() => t({
    comment: 'Pleditor comment mention user list header - Users with external access',
    message: 'External access',
})}';
      }

      /* Adds a border above the users without access header if we also render users with access or external */

      &:has(.ck-custom-mention-first-item-without-access):not(:first-child)::before,
      &:has(.ck-custom-mention-first-item-external):not(:first-child)::before {
        border-top: solid ${pxToRem(1)} ${theme.semantic.border.default};
      }
    }
  }

  .ck .mention {
    background: var(--ck-color-mention-background);
    color: var(--ck-color-mention-text);
  }
`;
const commonMentionStyles = css `
  background-color: transparent;
  font-weight: ${theme.fontWeight.semibold};
`;
const defaultMentionStyles = css `
  ${commonMentionStyles};
  color: ${theme.swatches.warm[500]};
`;
export const externalMentionBadgeThemeStyles = css `
  .ck-comment,
  .ck.ck-content {
    .mention[data-user-id] {
      ${defaultMentionStyles};
    }
  }
`;
const mentionExternalWithoutAccessStyles = css `
  ${commonMentionStyles};
  color: ${theme.semantic.foreground.primary};
`;
const mentionWithAccessStyles = css `
  ${commonMentionStyles};
  color: ${theme.semantic.foreground.primary};
`;
const commonBadgeStyles = css `
  &::after {
    display: inline-block;
    padding: ${theme.spacing.xs} ${theme.spacing.sm};
    margin-left: ${theme.spacing.sm};
    border-radius: ${theme.spacing.xs};
    font-size: ${pxToRem(8)};
    font-weight: ${theme.fontWeight.semibold};
    text-transform: uppercase;
    line-height: normal;
    pointer-events: none;
  }
`;
const mentionWithoutAccessStyles = css `
  ${commonMentionStyles};
  ${commonBadgeStyles};
  color: ${theme.semantic.foreground.primary};

  &::after {
    background-color: ${theme.swatches.yellow[500]};
    content: '${() => t({
    comment: 'Badge for mentioned user in comment without access to the document',
    message: 'No access',
})}';
  }
`;
const mentionExternalWithAccessStyles = css `
  ${commonMentionStyles};
  ${commonBadgeStyles};
  color: ${theme.swatches.warm[500]};

  &::after {
    color: ${theme.swatches.warm[500]};
    background-color: ${theme.semantic.surface.sunken};
    content: '${() => t({
    comment: 'Badge for mentioned user in comment with external access to the document',
    message: 'External',
})}';
  }
`;
export const appMentionBadgeThemeStyles = css `
  .ck-comment,
  .ck.ck-content {
    .mention[data-user-id^='email|'] {
      ${mentionExternalWithoutAccessStyles};
    }

    .mention.access {
      ${mentionWithAccessStyles};
    }

    .mention.no-access {
      ${mentionWithoutAccessStyles};
    }

    .mention.external {
      ${mentionExternalWithAccessStyles};
    }
  }
`;
